const theme = {
  // Base
  base: {
    fontBase: '16px',
  },

  border: {
    radius: '2.25em',
    color: '#f5f5f5',
  },

  grid: {
    gap: '2em',
    gapMobile: '1em',
  },

  // Responsive
  responsive: {
    wrap: 'calc(100% - 10rem)',
    wrapMobile: '85%',
  },

  // Space
  space: {
    space: '2rem',
    halfSpace: '1rem',
    quarterSpace: '0.5rem',
    gap: '2rem',
  },

  // Color
  color: {
    background: '#FFFFFF',
    backgroundAlt: '#B8EBD0',
    backgroundTert: '#f5f5f5',
    foreground: '#000000',
    foregroundAlt: '#5d2096',
    foregroundTert: '#41EAD4',
    callout: '#E43F6F',
    foregroundDim: '#a3a3a3',
    highlight: '#F6F740',
  },

  // Fonts
  font: {
    font: 'poppinsregular',
    fontMedium: 'poppinsmedium',
    bold: 'poppinsbold',
    fontBlack: 'poppinsblack',
    title: 'knewaveregular',
  },
};

export default theme;
